export default {
    baseUrl: process.env.NODE_ENV === 'production' ? 'http://39.96.81.236:8088' : '/api'
}
